/* eslint-disable import/no-cycle */
import { all } from "redux-saga/effects";
import { watchHomeAsync } from "./home";
import { watchTeamsAsync } from "./team";
import { watchUsersAsync } from "./user";
import { watchManagerAsync } from "./manager";
import { watchCompanyUsersAsync } from "./companyUsers";
import { watchCompanyKpisAsync } from "./companyKpis";
import { watchPerformanceAsync } from "./performance";
import { watchLeaderboardAsync } from "./leaderboard";
import { watchCoachupdAsync } from "./coachup";
import { watchCompetedAsync } from "./compete";
import { watchHubAsync } from "./hub";
import { watchNotificationsAsync } from "./notifications";

export function* rootSaga() {
  yield all([
    watchUsersAsync(),
    watchTeamsAsync(),
    watchCompanyUsersAsync(),
    watchCompanyKpisAsync(),
    watchHomeAsync(),
    watchManagerAsync(),
    watchPerformanceAsync(),
    watchLeaderboardAsync(),
    watchCoachupdAsync(),
    watchCompetedAsync(),
    watchHubAsync(),
    watchNotificationsAsync(),
  ]);
}
